import styled, { css } from 'styled-components';
import { TypographyStyles, focusOutline, media, spacing } from '../../../../../stylings';

export const Container = styled.div<{ $spaceBetween?: boolean }>`
  align-items: center;
  display: flex;
  gap: ${spacing.XXXS};
  height: 24px;

  ${({ $spaceBetween }) =>
    $spaceBetween &&
    css`
      justify-content: space-between;
    `}

  @media ${media.greaterThan('lg')} {
    height: 28px;
  }
`;
export const IDmeButton = styled.a`
  height: 22px;
  padding: 0;
  position: relative;
  width: 114px;

  &:focus {
    ${focusOutline}
  }

  @media ${media.greaterThan('lg')} {
    height: 26px;
    width: 134px;
  }
`;

export const DiscountAmount = styled.span`
  ${TypographyStyles.Body.Small.SemiBold}
`;
